import { render, staticRenderFns } from "./programUpdates.vue?vue&type=template&id=6d2ca7bf&scoped=true"
import script from "./programUpdates.vue?vue&type=script&lang=js"
export * from "./programUpdates.vue?vue&type=script&lang=js"
import style0 from "./programUpdates.vue?vue&type=style&index=0&id=6d2ca7bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2ca7bf",
  null
  
)

export default component.exports